var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFortnoxWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1521 316",
    width: 1521,
    height: 316,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FNOX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #003824 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m173.6 9h-79.7c-55.4 0-93.1 37.6-93.1 93v199.5c0 5.8 3.2 9 9 9h44.3c5.7 0 8.9-3.2 8.9-9v-82.8h110.9c5.7 0 8.9-3.2 8.9-8.9v-42.4c0-5.8-3.2-8.9-8.9-8.9h-111.2v-58c0-18.5 12.4-31 30.9-31h80c5.7 0 8.9-3.1 8.9-8.9v-42.7c0-5.7-3.2-8.9-8.9-8.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m452.1 188.7c0 71.1-52.9 126.6-125.9 126.6-73 0-125.9-55.5-125.9-126.6 0-71 52.6-126.5 125.9-126.5 73.3 0 125.9 55.5 125.9 126.5zm-60.5 0c0-38.8-27.5-66.9-65.4-66.9-37.9 0-65.3 28.1-65.3 66.9 0 38.9 27.7 67 65.3 67 37.9 0 65.4-28.1 65.4-67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m753.9 66.7h-75.5v-57.7c0-5.7-3.2-8.9-9-8.9h-44.2c-5.8 0-9 3.2-9 8.9v57.7h-53.2c-55.1 0-93 37.6-93 93v141.8c0 5.8 3.1 9 8.9 9h44.3c5.7 0 8.9-3.2 8.9-9v-143.7c0-18.5 12.4-30.9 30.9-30.9h53.2v90.5c0 55.5 37.6 93.1 93.1 93.1h44.3c5.7 0 8.9-3.2 8.9-9v-42.3c0-5.8-3.2-9-8.9-9h-44c-18.5 0-30.9-12.4-30.9-30.9v-92.4h75.5c5.8 0 8.9-3.2 8.9-8.9v-42.4c-0.3-6.1-3.5-8.9-9.2-8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m891.6 62.2c-67 0-110.9 43-110.9 108.7v131c0 5.7 3.2 8.9 8.9 8.9h44.3c5.7 0 8.9-3.2 8.9-8.9v-131c0-29.7 19.5-48.8 48.8-48.5 29.3-0.3 48.7 18.5 48.7 48.5v131c0 5.7 3.2 8.9 9 8.9h44.3c5.7 0 8.9-3.2 8.9-8.9v-131c0-65.7-44-108.7-110.9-108.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m1272.1 188.7c0 71.1-52.6 126.6-125.9 126.6-73 0-125.9-55.5-125.9-126.6 0-71 52.6-126.5 125.9-126.5 73 0 125.9 55.5 125.9 126.5zm-60.6 0c0-38.8-27.7-66.9-65.3-66.9-37.9 0-65.3 28.1-65.3 66.9 0 38.9 27.7 67 65.3 67 37.6 0 65.3-28.1 65.3-67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m1439.4 188.1l78.4-78.4q6.2-6.2 0-12.4l-30.9-30.9q-6.2-6.3-12.5 0l-78.3 78.4-78.4-78.4q-6.3-6.3-12.5 0l-30.9 30.9q-6.2 6.2 0 12.4l78.4 78.4-79 78.4q-6.2 6.2 0 12.4l30.9 30.9q6.2 6.2 12.4 0l78.4-78.4 78.4 78.4q6.2 6.2 12.4 0l31-30.9q6.2-6.2 0-12.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFortnoxWordmark);
export default __webpack_public_path__ + "static/media/FortnoxWordmark.adc9d7e326e2674e1d154e9e33e26ea6.svg";
export { ForwardRef as ReactComponent };